import * as React from 'react';
import store from "../../../storeWire";
import { system_notification } from "../../../store/slice/system";
import { useQuoteDetailStore } from 'src/hooks/quote-detail';
import { useCartStore } from 'src/hooks/cart';

const ClearCart = (props) => {
    const [{ CART_DATA }, { get_cart_quote_number }, { }] = useCartStore();
    const quoteNumber = get_cart_quote_number();
    const [{ get_current_quote_cart }, { }, { }] = useQuoteDetailStore();
    const quoteList = get_current_quote_cart();

    return (
        <>
            {((CART_DATA && CART_DATA.length > 0) || (quoteNumber && quoteList && Object.entries(quoteList).length > 0)) &&
                <div className="bs5 row">
                    <div className="col-12 text-end">
                        <a style={{ cursor: 'pointer' }} className="text-blue" data-toggle="modal" data-target="#CartClearAll"
                            onClick={() => {
                                store.dispatch(system_notification({
                                    name: 'ClearCartPopup',
                                    data: [],
                                }));
                            }}>Clear Cart</a>
                    </div>
                </div>
            }
        </>
    );
};

export default ClearCart;